var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1366,
    height: 768,
    viewBox: "0 0 1366 768",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1334.69 174.58L1334.63 173.825L1375.85 170.746L1508.59 143.706L1508.74 144.446L1375.96 171.485L1334.69 174.58Z",
    fill: "#4A97D2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1508.44 536.27L1335.72 403.291L1290.9 332.288L1291.54 331.896L1336.27 402.778L1508.91 535.666L1508.44 536.27Z",
    fill: "#4A97D2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1508.33 735.888L1393.83 483.972L1345.41 455.815L1275.38 379.483L1242.56 338.901L1243.15 338.433L1275.94 378.984L1345.93 455.272L1394.42 483.444L1394.48 483.549L1509.01 735.571L1508.33 735.888Z",
    fill: "#4A97D2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.61448 265.874L1.53906 264.38L347.727 244.678L552.972 192.516L723.223 148.839H723.313L815.973 148.296L833.123 169.493L960.234 159.845L1023.21 12.3132L1024.6 12.902L961.26 161.28L832.444 171.063L815.264 149.805L723.419 150.349L553.349 193.981L347.968 246.172L1.61448 265.874Z",
    fill: "#4A97D2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1007.91 565.996L893.067 548.121L892.991 548.076L814.495 490.207L814.465 490.147L761.838 407.911L762.471 407.504L815.053 489.694L893.369 547.411L1008.04 565.241L1007.91 565.996Z",
    fill: "#4A97D2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1006.1 506.482L1005.97 505.727L1131.9 484.848L1222.62 484.304L1222.68 484.319L1256.18 494.178L1394.1 483.338L1394.17 484.078L1256.1 494.948L1256.04 494.933L1222.51 485.059L1131.96 485.587L1006.1 506.482Z",
    fill: "#4A97D2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M579.896 618.46L579.791 618.445L400.339 594.545L153.915 585.593L0.347233 610.594L0.226562 609.854L153.87 584.838L400.399 593.806L579.776 617.675L688.575 567.204L725.183 507.418L725.349 507.388L814.706 489.588L814.856 490.328L725.651 508.098L689.103 567.793L688.997 567.838L579.896 618.46Z",
    fill: "#4A97D2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M722.951 149.7L718.336 132.715L694.699 132.851L694.609 132.76L544.631 12.902L545.098 12.3132L694.971 132.096L718.924 131.96L723.675 149.504L722.951 149.7Z",
    fill: "#4A97D2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1308.4 116.048L1209.39 75.7526L1209.34 75.6922L1150.24 12.8718L1150.79 12.3434L1209.83 75.1185L1308.68 115.338L1308.4 116.048Z",
    fill: "#4A97D2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M794.916 766.052L794.328 765.569L832.007 719.794L900.729 673.988L909.01 637.03L909.086 636.969L958.847 582.664L972.634 565.498L972.739 565.468L985.394 561.754L985.606 562.479L973.071 566.147L959.42 583.147L909.704 637.392L901.393 674.456L901.272 674.532L832.475 720.398L794.916 766.052Z",
    fill: "#4A97D2"
  })))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M1002.32 392.512L1002.3 391.002L1067.83 390.609L1161.84 383.408L1261.4 327.351L1311.97 334.1L1333.81 174.807L1306.03 169.296L1311.07 14.6079L1312.58 14.6532L1307.58 168.058L1335.5 173.599L1335.4 174.309L1313.26 335.791L1261.7 328.921L1162.3 384.887L1162.13 384.903L1067.89 392.119L1002.32 392.512Z",
    fill: "#4A97D2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M567.649 423.25L567.453 421.756L717.688 401.631L717.793 401.646L871.135 419.959L1002.15 391.017L1002.47 392.497L871.21 421.484L871.09 421.469L717.703 403.156L567.649 423.25Z",
    fill: "#4A97D2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1476.42 467.591L1350.86 381.627L1324.75 331.896L1341.73 265.12L1489.09 319.636L1476.42 467.591Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1493.14 286.981L1350.03 240.919L1349.73 188.576L1380.9 182.461L1502.22 166.352L1493.14 286.981Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1291.07 307.589L1311.76 188.787L1260.72 185.526L1247.7 294.575L1291.07 307.589Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1226.75 295.646L1097.25 289.306L1121.99 168.587L1176.7 175.124L1168.27 247.199L1223.55 246.867L1226.75 295.646Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1204.68 223.768L1220.79 181.978L1237.63 189.225L1226.36 228.252L1204.68 223.768Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1048.69 34.4158L1033.83 175.969L1104.12 186.447L1135.06 78.7268L1167.36 91.3935L1191.29 55.6428L1151.45 24.995L1048.69 34.4158Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1334.49 146.016L1348.82 33.4042L1487.35 23.0323L1471.08 114.734L1334.49 146.016Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M846.004 133.545L759.182 23.0322L996.978 21.1752L947.126 134.361L846.004 133.545Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1162.63 399.789L1243.7 484.561L1343.39 468.376L1325.49 457.114L1238.59 354.33L1162.63 399.789Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M619.068 34.3554L700.144 119.127L799.832 102.943L781.928 91.6803L725.545 24.995L619.068 34.3554Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1147.02 399.879L1206.1 465.387L1114.6 465.915L1075.07 400.302L1147.02 399.879Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1058.04 400.393L1108.66 476.378L1025.41 488.713L1005.46 406.281L1058.04 400.393Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1028.46 522.335L1055.07 631.157L1179.3 619.049L1170.23 580.248L1136.7 576.187L1119.23 505.441L1028.46 522.335Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1134.38 505.35L1141.29 551.412L1239.74 550.823L1235.15 494.691L1134.38 505.35Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.137 112.167L576.518 177.705L701.939 145.669L635.36 96.8586L560.137 112.167Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1292.5 550.521L1326.82 684.511L1422.34 669.172L1394.38 526.35L1292.5 550.521Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1311.91 693.132L1292.95 629.753L1234.26 630.1L1257.25 684.919L1311.91 693.132Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M937.669 190.991L958.093 406.552L819.895 392.829L813.665 299.557L883.971 299.149L890.593 340.728L910.473 340.607L898.678 267.731L724.053 275.854L718.984 192.274L937.669 190.991Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M784.25 291.132L794.251 379.211L724.669 379.618L724.111 285.803L784.25 291.132Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M689.119 370.59L677.655 188.953L566.307 208.972L578.494 388.994L689.119 370.59Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M851.375 434.543L874.001 515.194L947.127 538.715L939.148 445.157L851.375 434.543Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M657.531 435.675L697.036 507.917L775.562 477.39L737.686 421.514L657.531 435.675Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M741.172 530.185L874.814 654.482L939.961 583.026L814.871 507.222L741.172 530.185Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M725.681 553.843L840.725 672.584L764.07 734.725L663.898 673.626L659.026 688.436L668.348 705.693L591.843 735.737L580.062 656.203L697.46 581.713L725.681 553.843Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1067.31 302.773L1199 308.132L1162.33 347.702L1044.88 348.397L1067.31 302.773Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M995.65 187.081L1096.76 203.552L1088.04 283.674L1001.71 289.864L995.65 187.081Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1010.84 653.682L1146.9 635.852L1170.97 706.78L1014.22 711.49L1010.84 653.682Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M578.327 603.438L683.522 565.619L672.254 514.423L558.93 538.715L578.327 603.438Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.58236 552.273L151.847 544.633L60.4846 420.351H0.285156L1.58236 552.273Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.827 388.555L285.619 357.883L285.305 266.042L101 284.923L118.827 388.555Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M409.275 324.197L533.478 301.357L533.244 232.967L396 247.027L409.275 324.197Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.275 487.197L284.478 464.357L284.244 395.967L147 410.027L160.275 487.197Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.675 474.499L518.751 440.648L518.405 339.29L315 360.128L334.675 474.499Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.58398 269.694L55.9761 265.12L40.6208 310.034L1.58398 325.585V269.694Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M182.514 587.646L164.896 531.031L52.3707 383.559L1.46289 376.161L1.68915 374.666L53.2003 382.155L53.3813 382.396L166.253 530.321L183.947 587.193L182.514 587.646Z",
    fill: "#4A97D2"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M284.149 768L283.5 766.641L420.28 702.96L433.976 629.949L463.163 600.826L464.219 601.898L435.364 630.689L421.607 704.002L284.149 768Z",
    fill: "#4A97D2"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M286.682 249.72L256.786 203.703L184.957 145.759L0 135.116L0.0905027 133.606L185.515 144.28L185.712 144.431L257.918 202.677L287.949 248.905L286.682 249.72Z",
    fill: "#4A97D2"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16378 342.645L3.66602 341.226L49.1738 324.966L82.2978 260.152L83.6403 260.847L50.2447 326.189L4.16378 342.645Z",
    fill: "#4A97D2"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.369 96.8875L73.8134 42.0688L39 -24.2241L55.9843 -91L294.067 54.5242L169.369 96.8875Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.694 51.4911L86.7772 117.014L1.58398 119.928V40.9833L27.694 51.4911Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.511 160.192L434.667 117.27L374.438 71.178L261.113 95.4849L280.511 160.192Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M415.63 212L516 184.515L476.785 155L403 170.565L415.63 212Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.63 229L390 201.515L350.785 172L277 187.565L289.63 229Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M567.181 603.438L532.94 510.996L380.006 518.515L385.24 587.419L567.181 603.438Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.1 586.71L350.231 518.515L214.01 539.44L219.395 576.459L366.1 586.71Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M569.58 767.471L558.931 635.852L453.948 629.149L443.269 746.773L390.837 750.91L385.241 735.737L324.846 767.471H174.34H569.58Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.94 767.321L165.576 644.79L60.4869 663.964L8.46289 765.811L151.94 767.321Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.89 690.158L420.942 626.175L207.763 608.707L187.928 693.373L408.89 690.158Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.286262 247.773L169.858 245.433L184.912 154.833L0.0449219 142.619L0.286262 247.773Z",
    fill: "#213F9A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M497.658 126.888L402.102 72.0688L367.289 5.77594L384.273 -61L622.356 84.5242L497.658 126.888Z",
    fill: "#213F9A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBackground);
export default __webpack_public_path__ + "static/media/login-background.84f95ca733967d7b0f88e492a8f7810a.svg";
export { ForwardRef as ReactComponent };